// src/utils/marca.js

/**
 * Logo do cliente pelo FUNDO em que ela aparece — não pelo tema. A barra lateral só é
 * clara no plano com `menuClaro` (Laticínio) e no tema claro; nos outros planos ela é
 * azul (tema claro) ou quase preta (tema escuro), ou seja, sempre escura.
 *
 * - Fundo escuro: a logo para fundo escuro; sem ela, a de fundo claro (como era antes).
 * - Fundo claro: só a de fundo claro — a escura costuma ser branca e sumiria no branco.
 */
export const logoParaFundo = (cliente, fundoEscuro) =>
    (fundoEscuro ? cliente?.logoEscuroBase64 || cliente?.logoBase64 : cliente?.logoBase64) || null;

/** O cabeçalho da barra lateral é escuro? */
export const barraTemFundoEscuro = ({ menuClaro, modoEscuro }) => !menuClaro || modoEscuro;

/** Cor da prévia "fundo escuro" nas configurações: a da barra no tema escuro. */
export const FUNDO_ESCURO_MARCA = '#060A10';
